import React from 'react';
import { FelaComponent } from 'react-fela';

import withPageContext from '../pageContext';

import SEO from '../components/SEO';
import HeaderSection from '../components/Event/HeaderSection';
import FeaturesSection from '../components/Event/FeaturesSection';
import BrandingSection from '../components/Event/BrandingSection';
import MoreFeaturesSection from '../components/Event/MoreFeaturesSection';
import FeedbackSection from '../components/Event/FeedbackSection';
import ClientsSection from '../components/Event/ClientsSection';
import ContactsSection from '../components/Event/ContactsSection';
import Footer from '../components/Footer';

// Header assets
import peopleIcon from '../images/people.svg';

// Branding assets
import brandingImage from '../images/img_branding_conf_and_fest@2x.png';

import adminIcon from '../images/key-features-icons/ic_admin.svg';
import feedbackIcon from '../images/key-features-icons/ic_sharing.svg';
import languagesIcon from '../images/key-features-icons/ic_lang.svg';
import promoteIcon from '../images/key-features-icons/ic_brand.svg';
import statisticsIcon from '../images/key-features-icons/ic_stats.svg';
import visitorsIcon from '../images/key-features-icons/ic_info.svg';

// Feedback assets
import mightyScreen1 from '../images/testimonials/mighty_home.png';
import mightyScreen2 from '../images/testimonials/mighty_timeline.png';
import mightyAvatar from '../images/faces/img_face_mighty.png';

import mfdfScreen1 from '../images/testimonials/mfdf_home.png';
import mfdfScreen2 from '../images/testimonials/mfdf_timline.png';
import mfdfAvatar from '../images/faces/img_face_mfdf.png';

// Clients assets
import mightyLogo from '../images/logos/mighty.svg';
import vysocinaLogo from '../images/logos/vysocina.svg';
import jihlavaLogo from '../images/logos/jihlava.svg';
import jedensvetLogo from '../images/logos/jedensvet.svg';
import majalesLogo from '../images/logos/majales.svg';
import utuberingLogo from '../images/logos/utubering.svg';
import wearitLogo from '../images/logos/wearit.svg';
import festivalOneLogo from '../images/logos/festival_one.svg';
import indieLisboaLogo from '../images/logos/indielisboa.svg';
import afoLogo from '../images/logos/afo.svg';
import lfsuhLogo from '../images/logos/lfsuh.svg';
import be2canLogo from '../images/logos/be2can.svg';

// Assets assets
import { graphql, useStaticQuery } from 'gatsby';
import HeaderScroller from '../components/HeaderScroller';
import { LinkType } from '../components/Link/Link.style';
import useFeatures from '../components/Features/useFeatures';

const links = [
    { to: '/', labelId: 'home.menu.top', type: LinkType.GATSBY },
    { to: '/features', labelId: 'home.menu.features', type: LinkType.GATSBY },
    { to: '/festival', labelId: 'home.menu.festival', type: LinkType.GATSBY },
    { to: '/conference', labelId: 'home.menu.conference', type: LinkType.GATSBY },
    { to: '#contacts', labelId: 'home.menu.contacts', asButton: true, type: LinkType.NATIVE },
];

const info = [
    { titleId: 'festival.header.info.1.title', descId: 'festival.header.info.1.desc' },
    { titleId: 'festival.header.info.2.title', descId: 'festival.header.info.2.desc' },
    { image: peopleIcon, descId: 'festival.header.info.3.desc' },
    { titleId: 'festival.header.info.4.title', descId: 'festival.header.info.4.desc' },
];

const moreFeatures = [
    {
        titleId: 'festival.moreFeatures.1.title',
        descId: 'festival.moreFeatures.1.desc',
        image: (
            <img
                src={visitorsIcon}
                alt=""
                role="presentation"
                style={{ width: '64px', height: '65px', marginTop: '1px' }}
            />
        ),
    },
    {
        titleId: 'festival.moreFeatures.2.title',
        descId: 'festival.moreFeatures.2.desc',
        image: <img src={feedbackIcon} alt="" role="presentation" style={{ width: '85px', height: '70px' }} />,
    },
    {
        titleId: 'festival.moreFeatures.3.title',
        descId: 'festival.moreFeatures.3.desc',
        image: <img src={promoteIcon} alt="" role="presentation" style={{ width: '100px', height: '75px' }} />,
    },
    {
        titleId: 'festival.moreFeatures.4.title',
        descId: 'festival.moreFeatures.4.desc',
        image: <img src={languagesIcon} alt="" role="presentation" style={{ width: '79px', height: '61px' }} />,
    },
    {
        titleId: 'festival.moreFeatures.5.title',
        descId: 'festival.moreFeatures.5.desc',
        image: (
            <img
                src={adminIcon}
                alt=""
                role="presentation"
                style={{ width: '84px', height: '60px', marginTop: '3px' }}
            />
        ),
    },
    {
        titleId: 'festival.moreFeatures.6.title',
        descId: 'festival.moreFeatures.6.desc',
        image: (
            <img
                src={statisticsIcon}
                alt=""
                role="presentation"
                style={{ width: '77px', height: '62px', marginTop: '2px' }}
            />
        ),
    },
];

const feedback = [
    {
        authorId: 'festival.feedback.1.author',
        textId: 'festival.feedback.1.text',
        avatar: mightyAvatar,
        screen1: mightyScreen1,
        screen2: mightyScreen2,
    },
    {
        authorId: 'festival.feedback.2.author',
        textId: 'festival.feedback.2.text',
        avatar: mfdfAvatar,
        screen1: mfdfScreen2,
        screen2: mfdfScreen1,
    },
];

const clients = [
    { logo: mightyLogo, name: 'Mighty Sounds' },
    { logo: vysocinaLogo, name: 'Vysočina fest' },
    { logo: jihlavaLogo, name: 'MFDF Ji.hlava' },
    { logo: jedensvetLogo, name: 'Jeden svět' },
    { logo: majalesLogo, name: 'Majáles' },
    { logo: utuberingLogo, name: 'Utubering' },
    { logo: wearitLogo, name: 'Open House Praha' },
    { logo: festivalOneLogo, name: 'Open House Praha' },
    { logo: indieLisboaLogo, name: 'IndieLisboa — Festival Internacional de Cinema' },
    { logo: afoLogo, name: 'Academia Film Olomouc' },
    { logo: lfsuhLogo, name: 'Festival Letní filmová škola Uherské Hradištěc' },
    { logo: be2canLogo, name: 'Be2Can' },
];

const style = ({ theme }) => ({
    minHeight: '100vh',
    backgroundColor: theme.colors.black,
});

const IndexPage = () => {
    const { header } = useStaticQuery(
        graphql`
            query {
                header: file(relativePath: { eq: "img_header_fest.jpg" }) {
                    childImageSharp {
                        fluid(quality: 95, maxWidth: 2560) {
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
            }
        `,
    );

    const features = useFeatures();

    return (
        <FelaComponent style={style}>
            <SEO title="title.festival" desc="description.festival" />
            <HeaderScroller links={links} />
            <main>
                <HeaderSection
                    titleId="festival.header.title"
                    backgroundImage={header.childImageSharp.fluid}
                    info={info}
                />
                <FeaturesSection
                    features={features}
                    moreLink={'/features'}
                    titleId={'festival.features.title'}
                    buttonId={'festival.features.more'}
                />
                <BrandingSection image={brandingImage} />
                <MoreFeaturesSection features={moreFeatures} />
                <FeedbackSection feedback={feedback} />
                <ClientsSection clients={clients} />
                {/*<AssetsSection facebookImage={facebookImage} instagramImage={instagramImage} />*/}
                <ContactsSection titleId="home.contacts.title" />
            </main>
            <Footer />
        </FelaComponent>
    );
};

export default withPageContext(IndexPage);
